import { render } from "./EditRawMaterialModal.vue?vue&type=template&id=64a5ae70&ts=true"
import script from "./EditRawMaterialModal.vue?vue&type=script&lang=ts"
export * from "./EditRawMaterialModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__